import src from "IMAGE";
export default { src, width: 697, height: 96, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AAAAAAAFCggCFSAYCAkYEwgGDgwDDzMnDQsmHgcPLCIKGM8CAUF4yDYAAAAASUVORK5CYII="};
